"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionHelpers = void 0;
const TutorialHelpers_1 = require("./TutorialHelpers");
class AccordionHelpers {
    static buildAccordionHeaders(tutorial, flatSections, expandedItems) {
        var _a;
        if (!(tutorial === null || tutorial === void 0 ? void 0 : tutorial.tutorialSteps)) {
            return { headers: [], newExpandedItems: [] };
        }
        const previousExpandedItems = [...expandedItems];
        const headers = tutorial.tutorialSteps.map((step, stepIndex) => {
            const stepSections = TutorialHelpers_1.TutorialHelpers.getSectionsForStep(flatSections, stepIndex);
            const stepId = `step-${stepIndex}`;
            const wasExpanded = previousExpandedItems.includes(stepId);
            const shouldExpand = previousExpandedItems.length > 0 ? wasExpanded : stepIndex === 0;
            return {
                id: stepId,
                trueId: step.id,
                title: step.title || 'tutorial.unnamedStep'.t(),
                expanded: shouldExpand,
                sections: stepSections
            };
        });
        const newExpandedItems = previousExpandedItems.length > 0
            ? previousExpandedItems
            : [(_a = headers[0]) === null || _a === void 0 ? void 0 : _a.id].filter(Boolean);
        return { headers, newExpandedItems };
    }
    static toggleAccordion(expandedItems, itemId) {
        const index = expandedItems.indexOf(itemId);
        if (index > -1) {
            return expandedItems.filter(id => id !== itemId);
        }
        return [...expandedItems, itemId];
    }
}
exports.AccordionHelpers = AccordionHelpers;
